/** Same math as SecurityTableRow deviation column. */
export const resolvePortfolioWidgetDeviation = ({
  valueCents,
  expectedValueCents,
  pendingTradesCents = 0,
}: {
  valueCents: number;
  expectedValueCents: number;
  pendingTradesCents?: number;
}): { deviationCents: number; deviationPercentage: number } => {
  const deviationCents = valueCents + pendingTradesCents - expectedValueCents;
  const roundedBase = Math.round(expectedValueCents);
  const deviationPercentage =
    roundedBase === 0 ? 0 : Math.round(deviationCents) / roundedBase;

  return { deviationCents, deviationPercentage };
};
